import { ReactNode } from "react";
import { ChangeRole } from "@components/molecules/ToggleRole";
import { CanAccess } from "@refinedev/core";

export interface CommonTemplateProps {
    children?: ReactNode
}

export function AppTemplate({ children }: CommonTemplateProps) {

    // logger.debug(role)
    return <>
        {children}
        <CanAccess resource="debugging" action="show">
            <div className="fixed z-50 top-0 left-0 opacity-25 hover:opacity-100">
                <ChangeRole/>
            </div>
        </CanAccess>
    </>
}
